<template>
  <v-card class="mr-6 card-outter pb-0" height="100%">
    <v-menu bottom left>
      <template v-slot:activator="{ on, attrs }">
        <v-btn color="#b7b7b7" icon style="float: right" v-bind="attrs" v-on="on">
          <v-icon>mdi-cog</v-icon>
        </v-btn>
      </template>
      <v-list>
        <v-list-item v-for="(item, i) in items" :key="i">
          <!--<v-list-item-title><a :href="item.path">{{ item.title }}</a></v-list-item-title>-->
          <v-list-item-action
            v-if="item.title == 'Send Email'"
            @click="SendEmail(user.email)"
            >{{ item.title }}</v-list-item-action
          >
          <v-list-item-action
            v-if="item.title == 'Assign to Courses'"
            @click.prevent="showEnrolPanel(user.id, 1)"
            >{{ item.title }}</v-list-item-action
          >
          <v-list-item-action
            v-if="item.title == 'Assign to Playlists'"
            @click.prevent="showPlaylistEnrolPanel(user.id, 1)"
            >{{ item.title }}</v-list-item-action
          >
          <v-list-item-action
            v-if="item.title == 'User Summary'"
            @click.prevent="viewSummary(user.id)"
            >{{ item.title }}</v-list-item-action
          >
          <v-list-item-action
            v-if="item.title == 'Edit User'"
            @click.prevent="showEditPanel(user.id)"
            >{{ item.title }}</v-list-item-action
          >
        </v-list-item>
      </v-list>
    </v-menu>
    <v-card-title>
        <v-avatar size="47"  class="avtar">
          <template v-if="user.company_logo.url">
          <img :src="user.company_logo.url" alt="User Image">
          </template>
         <template v-else>
            <span class="avatar-text">{{ user.first_name.charAt(0).toUpperCase()  +  user.last_name.charAt(0).toUpperCase()}}</span>
          </template>
        </v-avatar>
      <span class="user-name"> {{ user.first_name }} {{ user.last_name }} </span>
      </v-card-title>
    <v-card-actions>
      <v-list-item class="grow">
        <v-list-item-content>
          <v-list-item-title
            ><strong>Assigned Courses</strong><br />{{
              user.total_courses
            }}</v-list-item-title
          >
        </v-list-item-content>

        <v-row align="center" justify="end">
          <span class="subheading mr-2"
            ><strong>Last log in</strong><br />{{ user.last_login }}</span
          >
        </v-row>
      </v-list-item>
    </v-card-actions>
  </v-card>
</template>
<script>
import { IMPROVE_CONFIG } from '@/config.js';
import thumbSizes from '@/utils/thumbs.js';
import SendEmail from '@/components/manager/SendEmail';
import EditUser from '@/components/admin/users/Edit';
import EnrolCourse from '@/components/admin/users/EnrolCourse';
import EnrolPlaylist from '@/components/admin/users/EnrolPlaylist';

export default {
  name: 'UserCard',
  props: {
    user: {
      type: Object,
      default: null,
    },
    mini: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      items: [
        { title: 'Send Email' },
        { title: 'Assign to Courses' },
        { title: 'Assign to Playlists' },
        { title: 'User Summary' },
        { title: 'Edit User' },
      ],
    };
  },
  computed: {
    imgSrc: function () {
      if (this.user.company_logo != null) {
        if (this.user.company_logo.hasOwnProperty('data')) {
          const imageRequest = JSON.stringify({
            bucket: `${IMPROVE_CONFIG.BUCKET}`,
            key: this.user.company_logo.data.key,
            edits: thumbSizes.medium,
          });
          const url = `${IMPROVE_CONFIG.SERVERLESS_IMAGE_HANDLER}/${btoa(
            imageRequest
          )}`;
          return url;
        } else {
          const imageRequest = JSON.stringify({
            bucket: `${IMPROVE_CONFIG.BUCKET}`,
            key: this.user.company_logo.key,
            edits: thumbSizes.medium,
          });
          const url = `${IMPROVE_CONFIG.SERVERLESS_IMAGE_HANDLER}/${btoa(
            imageRequest
          )}`;
          return url;
        }
      } else {
        return 'https://via.placeholder.com/350';
      }
    },
  },
  methods: {
    SendEmail: function (email) {
      this.$showPanel({
        component: SendEmail,
        props: {
          params: this.params,
          emailAddress: email,
        },
        openOn: 'right'
      });
    },
    showEditPanel(id) {
      this.$showPanel({
        component: EditUser,
        props: {
          id: id,
          params: this.params,
          locations: []
        },
        openOn: 'right',
      });
    },
    viewSummary(id) {
      this.$router.push('profile/summary/' + id);
    },
    showEnrolPanel(id, el) {
      this.$showPanel({
        component: EnrolCourse,
        disableBgClick: true,
        props: {
          id: id,
          params: this.params,
          elm: el,
        },
        openOn: 'right',
      });
    },
    showPlaylistEnrolPanel(id, el) {
      this.$showPanel({
        component: EnrolPlaylist,
        disableBgClick: true,
        props: {
          id: id,
          params: this.params,
          elm: el,
        },
        openOn: 'right',
      });
    },
  },
};
</script>
<style>
.card-outter {
  position: relative;
  padding-bottom: 50px;
}
.card-actions {
  position: absolute;
  bottom: 0;
}
.zoom {
  padding: 50px;
  background-color: green;
  transition: transform 0.2s; /* Animation */
  width: 200px;
  height: 200px;
  margin: 0 auto;
}

.zoom:hover {
  transform: scale(
    1.5
  ); /* (150% zoom - Note: if the zoom is too large, it will go outside of the viewport) */
}
.v-toolbar__content,
.v-toolbar__extension {
  padding: 4px 10px !important;
}
.v-list-item__action {
  cursor: pointer;
}
.avtar{
  background-color: #EFF8F4;
}
</style>
